import { LANG } from "@/constants/Language";
import ContentLevel from "@/types/models/ContentLevel.interface";

export const findHighestLevelBelowReadingLevel = (
  sortedContentLevels: ContentLevel[],
  readingLevelLexileRange: number[],
  language: LANG,
) => {
  const levelsBelowReadingLevel = sortedContentLevels.filter((level) => {
    if (language) {
      return (
        level.raw_lexile < (readingLevelLexileRange[0] || 0) &&
        level.language === language
      );
    }

    return level.raw_lexile < (readingLevelLexileRange[0] || 0);
  });

  return levelsBelowReadingLevel[levelsBelowReadingLevel.length - 1];
};
